import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  Oe,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/icons/jb-read-icon/jb-read-icon.scss?inline
var jb_read_icon_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

svg {
  fill: rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
  stroke: rgba(20, 30, 85, var(--theme-opacity-20, 0.2));
}
svg circle {
  fill: transparent;
}`;

// src/components/icons/jb-read-icon/jb-read-icon.ts
var JbReadIcon = class extends h {
  constructor() {
    super(...arguments);
    this.circle = Oe`<circle cx="13" cy="13" r="12.5"/>`;
    this.withCircle = false;
  }
  render() {
    return ke` <svg
      width="26"
      height="26"
      viewbox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
    >
      ${this.withCircle ? this.circle : D}
      <path
        d="M13.001 8.021c-.831-.673-2.276-1.02-4.314-1.02a21.037 21.037 0 0 0-2.998.22.221.221 0 0 0-.189.216v10.471c0 .064.029.125.08.166.05.042.118.06.183.05a20.91 20.91 0 0 1 2.908-.213c2.026 0 3.47.354 4.173 1.024a.22.22 0 0 0 .244.047.278.278 0 0 0 .064-.04c1.733-1.621 7.03-.822 7.084-.815a.222.222 0 0 0 .183-.05.209.209 0 0 0 .08-.166V7.456a.22.22 0 0 0-.177-.234c-.221-.034-5.315-.824-7.32.8zm-.563 9.735c-.775-.505-2.018-.759-3.69-.759-.815.003-1.63.056-2.438.16V8.16a19.11 19.11 0 0 1 2.453-.168c1.758 0 3.026.3 3.675.867v8.897zm7.274-.602c-.948-.125-4.43-.486-6.123.604V8.865c1.44-1.25 5.267-.827 6.123-.7v8.989zm-8.21-4.876c0 .169-.102.305-.228.305H7.423c-.126 0-.228-.136-.228-.305 0-.168.102-.305.228-.305h3.851c.126 0 .228.137.228.305zm-4.06-2.12h3.852c.125 0 .227.137.227.306 0 .168-.102.305-.227.305H7.442c-.126 0-.228-.137-.228-.305 0-.169.102-.305.228-.305zm4.06 3.864c0 .168-.102.305-.228.305H7.423c-.126 0-.228-.137-.228-.305 0-.169.102-.305.228-.305h3.851c.06 0 .119.032.161.09a.364.364 0 0 1 .067.215zm7.296-1.744c0 .169-.102.305-.228.305h-3.858c-.126 0-.228-.136-.228-.305 0-.168.102-.305.228-.305h3.852a.2.2 0 0 1 .165.086.363.363 0 0 1 .069.22zm0-1.855c0 .168-.102.305-.228.305h-3.858c-.126 0-.228-.137-.228-.305 0-.169.102-.306.228-.306h3.852a.2.2 0 0 1 .165.087.363.363 0 0 1 .069.219zm0 3.599c0 .168-.102.305-.228.305h-3.858c-.126 0-.228-.137-.228-.305 0-.169.102-.305.228-.305h3.852a.2.2 0 0 1 .165.086.363.363 0 0 1 .069.219z"
      />
    </svg>`;
  }
};
JbReadIcon.styles = r(jb_read_icon_default);
__decorateClass([
  n({ type: Boolean })
], JbReadIcon.prototype, "withCircle", 2);
JbReadIcon = __decorateClass([
  customElement("jb-read-icon")
], JbReadIcon);

export {
  JbReadIcon
};
